import { render, staticRenderFns } from "./TreatmentRoom.vue?vue&type=template&id=403ae4a0&"
import script from "./TreatmentRoom.vue?vue&type=script&lang=js&"
export * from "./TreatmentRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports